import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
    Box,
} from '@mui/material';
import { GallopDataType, GallopItem } from '../../shared/types/gallopData.type';
import { t } from 'i18next';
import { formatDate } from '../../shared/utils/DateUtils';
import { compact, isEmpty, upperCase } from 'lodash';
import palette from '../../theme/palette';
import styled from 'styled-components';

function KeyParamTable({ data, allSameDate, showMetadata = false, avgParams = {} }: {
    allSameDate: boolean,
    data?: GallopItem[],
    showMetadata?: boolean,
    isEmptyGroups?: boolean,
    avgParams?: Record<string, string>,

}) {

    const trainings = data || [];

    const keyParams = (() => {
        try {
            const training = trainings.find(training => !isEmpty(training?.split_times));
            return training?.key_parameters.map(kp => ({
                ...kp.key_parameter_layout.insight_parameter,
                highlighted: kp.highlighted,
                recupColor: kp?.color
            })) ?? [];
        } catch (error) {
            console.error('couldn’t get insight param: ', error);
            return [];
        }
    })();



    return (
        <TableContainer
            component={Paper}
            sx={{
                border: '1px solid black',
            }}
        >
            <Table size="small"
                sx={{
                    '& td, & th': {
                        fontSize: '12px',
                    },
                    '& th': {
                        lineHeight: '1.1',
                    }
                }}
            >
                <TableHead>
                    <TableRow
                        sx={{
                            background: `linear-gradient(to right, ${palette.light.primary.darker}, ${palette.light.primary.main})`,
                            color: 'white',
                        }}
                    >
                        {
                            showMetadata && <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}>
                                {`${t('date')} - ${t('eap:table:headers:trackName')} - ${t('eap:table:headers:trackCondition')}`}
                            </TableCell>
                        }

                        <TableCell align="center" sx={{ color: 'white', fontWeight: 600, whiteSpace: 'nowrap' }}>
                            {t('horse')}
                        </TableCell>
                        {keyParams.map((param) => (
                            <TableCell key={param.name} align="center"
                                sx={{ color: 'white', fontWeight: 600, paddingInline: 1 }}>
                                {`${param?.short_name_translated ?? param.name_translated}`}
                                <br /> {`(${param.unit_translated})`}

                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody
                    sx={{
                        width: '100%',
                        '& td, & th': {
                            padding: '0px !important',
                            boxSizing: 'border-box',
                        },

                    }}
                >
                    {trainings.map((training, index) => (
                        <>
                            <TableRow key={index} className="listItemExam" sx={{ breakInside: 'avoid' }}>
                                {
                                    showMetadata && <TableCell
                                        sx={{
                                            padding: 1,
                                        }}
                                        align="center">
                                        <Typography fontSize={'12px'} fontWeight={600}>
                                            {
                                                compact([
                                                    formatDate(training.creation_date, allSameDate ? 'HH:mm' : 'DD/MM/YYYY'),
                                                    training.track_name?.display_name,
                                                    training.track_condition?.display_name]).join(' - ')
                                            }
                                        </Typography>
                                    </TableCell>
                                }

                                <TableCell sx={{ whiteSpace: 'nowrap' }} align="center">
                                    <Typography whiteSpace={'nowrap'} fontSize={'12px'}>
                                        {training?.horse?.name}
                                    </Typography>
                                </TableCell>
                                {keyParams.map((param) => {


                                    const value = training.key_parameters.find(kp =>
                                        kp.key_parameter_layout.insight_parameter.name === param.name
                                    );

                                    const isHighlighted = training.key_parameters.find(kp =>
                                        kp.key_parameter_layout.insight_parameter.name === param.name
                                    )?.highlighted;

                                    return (
                                        <TableCell
                                            key={param.name}
                                            align="center"
                                            sx={{

                                                position: 'relative',
                                                padding: 1,
                                                ...(value?.color ? {
                                                    backgroundColor: value.color,
                                                } : {})
                                            }}

                                        >
                                            <Box position={'relative'} display="flex" flexDirection="column"
                                                alignItems="center" gap={'3px'}>

                                                <Typography
                                                    fontSize={'12px'}
                                                    className={isHighlighted ? 'highlighted' : ''}
                                                >

                                                    {value?.formatted_value || '-'}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                            {
                                //If Last training Item
                                trainings.length - 1 === index &&
                                <TableRow key='avgs' sx={{ backgroundColor: palette.light.primary.lighter, breakInside: 'avoid' }} >
                                    <TableCell
                                        colSpan={showMetadata ? 2 : 1}
                                        sx={{
                                            fontWeight: 600
                                        }}
                                        align="center"
                                    >
                                        {upperCase(t('average'))}
                                    </TableCell>
                                    {keyParams.map((param) => {

                                        const avg_keys = Object.keys(avgParams)


                                        return (
                                            <TableCell
                                                align="center"
                                                sx={{ padding: 1, fontWeight: 600 }}
                                            >{avg_keys.includes(param.name) ? avgParams[param.name] : '-'}</TableCell>)
                                    })}
                                </TableRow>
                            }
                        </>

                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
        ;
}
export default KeyParamTable;
